import { render } from "./DocumentsPage.vue?vue&type=template&id=797122fc&ts=true"
import script from "./DocumentsPage.vue?vue&type=script&lang=ts"
export * from "./DocumentsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__